import { ActionTypes } from '../../constants';
import checkLogin from '../setters/checkLogin';
import getFromGql from '../api/getFromGql';
import gql from 'graphql-tag';

const MUTATION = gql`
  mutation disconnectStrava {
    disconnectFitness
  }
`;

export default () => async (dispatch, _getState, auth) => {
  await dispatch(checkLogin());
  dispatch({ type: ActionTypes.UNLINK_STRAVA });

  try {
    const res = await dispatch(getFromGql(MUTATION));

    if (!res) {
      throw new Error('No response');
    }
    if (res.errors && res.errors.length > 0) {
      throw new Error(res.errors[0].message);
    }
    dispatch({ type: ActionTypes.UNLINK_STRAVA_SUCCESS });
    return Promise.resolve();
  } catch (error) {
    dispatch({ type: ActionTypes.UNLINK_STRAVA_FAILURE });
    return Promise.reject();
  }
};
